/* -----------------UI--------------- */
import type { Distribution } from "@memorang/types/src/content";

import Box from "@memorang/ui/src/components/Box";
import DonutChart from "@memorang/ui/src/components/DonutChart";
import ProductIcon from "@memorang/ui/src/components/ProductIcon";
import { QuickActionChips } from "@memorang/ui/src/components/QuickActionChips";
/* -----------------Components--------------- */
import RowStats, { type Stat } from "@memorang/ui/src/components/RowStats";
import type { QuickActionsChipType } from "@memorang/ui/src/types";

/* -----------------Props--------------- */
type Props = {
	distribution: Distribution;
	title: string;
	image?: string;
	stats?: Stat[];
	handleQuickActionPress: (action: QuickActionsChipType["type"]) => void;
	actionChips: QuickActionsChipType[];
};

/* -----------------Component--------------- */
const ContentHero = (props: Props) => {
	const { distribution, stats, image, handleQuickActionPress, actionChips } =
		props;

	const HeroOverallProgressDonutChart = () => {
		return (
			<>
				{image && (
					<DonutChart distribution={distribution} radius={64} innerRadius={50}>
						<ProductIcon image={image} size={64} />
					</DonutChart>
				)}
			</>
		);
	};

	const showStats = stats?.length;

	const Stats = () => <RowStats stats={stats || []} />;

	return (
		<>
			<Box padding={16} gap={16}>
				<HeroOverallProgressDonutChart />
				{showStats ? <Stats /> : null}
			</Box>
			<Box paddingBottom={8}>
				<QuickActionChips
					quickActionsChips={actionChips}
					handleQuickActionPress={handleQuickActionPress}
				/>
			</Box>
		</>
	);
};

export default ContentHero;
